import { GlobalDesignAction } from '../types';
import { rootHostGroupingStrategy } from '../common/grouping/rootHostGroupingStrategy';

export const globalColorsGrouping: GlobalDesignAction<'globalColorsStyles'>['grouping'] =
  {
    getGroupingStrategy: (editorPointer, getHost) => {
      return () => {
        return rootHostGroupingStrategy(editorPointer, getHost);
      };
    },
  };
